import { defineComponent as _defineComponent } from 'vue'
import { mdiEmailOutline, mdiFacebook, mdiInstagram, mdiTwitter } from '@mdi/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'TheFooter',
  setup(__props) {

const currentYear = new Date().getFullYear()

return { __sfc: true,currentYear, mdiEmailOutline, mdiFacebook, mdiInstagram, mdiTwitter }
}

})